import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React, { memo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import RegionCard from '../../components/BasicUI/Cards/RegionCard';
import { routeConfiguration } from '../../index';
import { createResourceLocatorString } from '../../util/routes';

const destinations = [
  {
    title: 'Berlin',
    subtitle: 'Wohnmobilstellplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/640x427/5ed05303bd/berlin.webp',
      alt: 'Lavendel Wiesen in Frankreich',
      title: 'Lavendel Wiesen in Frankreich',
    },
    slug: 'wohnmobilstellplatz',
    rest: 'berlin',
  },

  {
    title: 'Hamburg',
    subtitle: 'Wohnmobilstellplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/640x478/4f59deeafd/hamburg.webp',
      alt: 'Italy Coast',
      title: 'Italy Coast',
    },
    slug: 'wohnmobilstellplatz',
    rest: 'hamburg',
  },
  {
    title: 'München',
    subtitle: 'Wohnmobilstellplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/640x427/725b602969/muenchen.webp',
      alt: 'Splash of Germany Bayern Castle',
      title: 'Splash of Germany Bayern Castle',
    },
    slug: 'wohnmobilstellplatz',
    rest: 'muenchen',
  },
  {
    title: 'Köln',
    subtitle: 'Wohnmobilstellplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/640x962/989b92390f/koeln.webp',
      alt: 'City skyline of cologne',
      title: 'City skyline of cologne',
    },
    slug: 'wohnmobilstellplatz',
    rest: 'koeln',
  },
  {
    title: 'Frankfurt',
    subtitle: 'Wohnmobilstellplätze',
    image: {
      filename:
        'https://a.storyblok.com/f/267180/640x480/56622d2376/sinan-erg-xh7iycrfmfs-unsplash-_1_.webp',
      alt: 'City skyline of cologne',
      title: 'City skyline of cologne',
    },
    slug: 'wohnmobilstellplatz',
    rest: 'frankfurt',
  },
  {
    title: 'Dortmund',
    subtitle: 'Wohnmobilstellplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/640x427/97955b9f00/dortmund.webp',
      alt: 'Dortmunder Union Tower',
      title: 'Dortmunder Union Tower',
    },
    slug: 'wohnmobilstellplatz',
    rest: 'dortmund',
  },
  {
    title: 'Nürnberg',
    subtitle: 'Wohnmobilstellplätze',
    image: {
      filename:
        'https://a.storyblok.com/f/267180/640x427/2948c1d68d/markus-spiske-yeay6ua92rw-unsplash.webp',
      alt: 'Wohnmobilstellplatz Nürnberg',
      title: 'Wohnmobilstellplatz Nürnberg',
    },
    slug: 'wohnmobilstellplatz',
    rest: 'nuernberg',
  },

  {
    title: 'Hannover',
    subtitle: 'Wohnmobilstellplätze',
    image: {
      filename:
        'https://a.storyblok.com/f/267180/640x414/555826bb31/lu-moreno-ny2mrbjwroi-unsplash.webp',
      alt: 'view of hannover',
      title: 'view of hannover',
    },
    slug: 'wohnmobilstellplatz',
    rest: 'hannover',
  },
  {
    title: 'Stuttgart',
    subtitle: 'Wohnmobilstellplätze',
    image: {
      filename:
        'https://a.storyblok.com/f/267180/640x386/d65d0ccc6a/kumas_taverne-5tvikh12msa-unsplash.webp',
      alt: 'view of stuttgart',
      title: 'view of stuttgart',
    },
    slug: 'wohnmobilstellplatz',
    rest: 'stuttgart',
  },
  {
    title: 'Salzburg',
    subtitle: 'Wohnmobilstellplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/640x960/fcb0593d1e/salzburg-480p.webp',
      alt: 'view of salzburg',
      title: 'view of salzburg',
    },
    slug: 'wohnmobilstellplatz',
    rest: 'salzburg',
  },
  {
    title: 'Rostock',
    subtitle: 'Wohnmobilstellplätze',
    image: {
      filename:
        'https://a.storyblok.com/f/267180/640x427/e3c6c752ff/samuel-svec-fhkzznwqoby-unsplash-_1_.webp',
      alt: 'Coast of Rockstock',
      title: 'Coast of Rockstock',
    },
    slug: 'wohnmobilstellplatz',
    rest: 'rostock',
  },
  {
    title: 'Dresden',
    subtitle: 'Wohnmobilstellplätze',
    image: {
      filename:
        'https://a.storyblok.com/f/267180/640x428/508ee0e9e3/vasily-malygin-iwcoxmnnqbo-unsplash.webp',
      alt: 'Wohnmobilstellplatz Dresden',
      title: 'Wohnmobilstellplatz Dresden',
    },
    slug: 'wohnmobilstellplatz',
    rest: 'dresden',
  },
  {
    title: 'Leipzig',
    subtitle: 'Wohnmobilstellplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/480x280/581fcd1319/leipzig-480p.webp',
      alt: 'Wohnmobilstellplatz Leipzip',
      title: 'Wohnmobilstellplatz Leipzip',
    },
    slug: 'wohnmobilstellplatz',
    rest: 'leipzig',
  },
  {
    title: 'Wismar',
    subtitle: 'Wohnmobilstellplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/640x480/1ba892a26b/wismar-480p.webp',
      alt: 'Wohnmobilstellplatz Leipzip',
      title: 'Wohnmobilstellplatz Leipzip',
    },
    slug: 'wohnmobilstellplatz',
    rest: 'wismar',
  },
  {
    title: 'Bremerhaven',
    subtitle: 'Wohnmobilstellplätze',
    image: {
      filename:
        'https://a.storyblok.com/f/267180/640x431/80061315b5/free-nomad-rtuhxpdkv4c-unsplash.webp',
      alt: 'Wohnmobilstellplatz Bremerhaven',
      title: 'Wohnmobilstellplatz Bremerhaven',
    },
    slug: 'wohnmobilstellplatz',
    rest: 'bremerhaven',
  },
  // Add more destinations as needed
];

const SectionCitiesComponent = () => {
  const intl = useIntl();

  return (
    <Container
      maxWidth="xl"
      sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 4 }}
    >
      <Typography component="h2" sx={{ mb: 2 }} variant="h3">
        <FormattedMessage id="SectionCities.header" />
      </Typography>
      <Grid container justifyContent="center" spacing={2}>
        {destinations.map((destination, index) => {
          const link = createResourceLocatorString(
            'StoryblokPage',
            routeConfiguration(),
            { slug: destination.slug, rest: destination.rest },
            {},
            intl.locale,
          );

          return (
            <Grid key={index} size={{ lg: 4, md: 6, xs: 12 }}>
              <RegionCard
                image={destination.image}
                link={link}
                subtitle={destination.subtitle}
                title={destination.title}
              />
            </Grid>
          );
        })}
      </Grid>
    </Container>
  );
};

SectionCitiesComponent.displayName = 'SectionCities';
const SectionCities = memo(SectionCitiesComponent);
export default SectionCities;
